import { idb } from "../db/index.ts";
import { g } from "../util/index.ts";

/**
 * A3 stat-meaningfulness gate (MOBILE_CONTENT_FIRST_PLAN_2026-07-06.md):
 * current regular-season games played by the user's team. Returns undefined
 * for historical/career/all scopes and non-regular-season splits so the UI
 * gate never hides archived data.
 */
export const getUserTeamGamesPlayed = async (
	season: number | "career" | "all",
	playoffs?: string,
): Promise<number | undefined> => {
	if (season !== g.get("season")) {
		return undefined;
	}

	if (playoffs !== undefined && playoffs !== "regularSeason") {
		return undefined;
	}

	const teamSeason = await idb.cache.teamSeasons.indexGet(
		"teamSeasonsByTidSeason",
		[g.get("userTid"), g.get("season")],
	);

	if (!teamSeason) {
		return 0;
	}

	return teamSeason.won + teamSeason.lost + teamSeason.tied + teamSeason.otl;
};
